<ng-container *transloco="let t; prefix: 'edit-collection-tags'">

  <app-edit-modal-shell
    [title]="t('title', {collectionName: tag().title})"
    [translocoPrefix]="'edit-collection-tags'"
    [field]="formGroup"
    [(activeTabId)]="activeTab"
    (close)="close()"
    (save)="save()"
  >

    <ng-template [appEditTab]="Tabs.General">
      <div class="row g-0 mb-3">
        <div class="col-md-8 col-sm-12">
          <label for="library-name" class="form-label">{{t('name-label')}}</label>
          <input id="library-name" class="form-control" [formField]="formGroup.title" type="text"
                 [appFormField]="formGroup.title" aria-describedby="library-name-validations">

          <app-validation-errors [control]="formGroup.title" inputId="library-name" [messages]="{duplicateName: t('name-validation')}" />
        </div>
        <div class="col-md-3 col-sm-12 ms-2">
          <div class="form-check form-switch">
            <input type="checkbox" id="tag-promoted" role="switch" [formField]="formGroup.promoted" class="form-check-input" switch
                   aria-labelledby="auto-close-label" aria-describedby="tag-promoted-help">
            <label class="form-check-label me-1" for="tag-promoted">{{t('promote-label')}}</label>
            <i class="fa fa-info-circle" aria-hidden="true" placement="left" [ngbTooltip]="promotedTooltip" role="button" tabindex="0"></i>
            <ng-template #promotedTooltip>{{t('promote-tooltip')}}</ng-template>
            <span class="visually-hidden" id="tag-promoted-help"><ng-container [ngTemplateOutlet]="promotedTooltip" /></span>
          </div>
        </div>
      </div>

      <div class="row g-0 mb-3">
        <label for="summary" class="form-label">{{t('summary-label')}}</label>
        <textarea id="summary" class="form-control" [formField]="formGroup.summary" rows="3"></textarea>
      </div>
    </ng-template>

    @if (tag().source === ScrobbleProvider.Kavita) {
      <ng-template [appEditTab]="Tabs.Series">
        @if (!isLoading()) {
          <div class="list-group">
            <div class="row g-0 mb-3">
              <app-filter-field [(query)]="filterQuery" [label]="t('filter-label')" />
            </div>
            <div class="form-check">
              <input id="select-all" type="checkbox" class="form-check-input" [disabled]="tag().source !== ScrobbleProvider.Kavita"
                     [checked]="seriesTracker.allSelected()" (change)="toggleAll()" [indeterminate]="seriesTracker.hasSomeSelected()">
              <label for="select-all" class="form-check-label">{{seriesTracker.allSelected() ? t('deselect-all') : t('select-all')}}</label>
            </div>
            <ul>
              @for (item of filteredSeries(); let i = $index; track item.id) {
                <li class="list-group-item">
                  <div class="form-check">
                    <input id="series-{{i}}" type="checkbox" class="form-check-input" [disabled]="tag().source !== ScrobbleProvider.Kavita"
                           [checked]="seriesTracker.isSelected(item)" (change)="handleSelection(item)">
                    <label for="series-{{i}}" class="form-check-label">{{item.name}} ({{libraryName(item.libraryId)}})</label>
                  </div>
                </li>
              }
            </ul>
            @if (series().length !== 0 && pagination().totalPages > 1) {
              <div class="d-flex justify-content-center">
                <ngb-pagination [page]="pagination().currentPage"
                  [pageSize]="pagination().itemsPerPage"
                  (pageChange)="onPageChange($event)"
                  [rotate]="false" [ellipses]="false" [boundaryLinks]="true"
                  [collectionSize]="pagination().totalItems" />
              </div>
            }
          </div>
        }
      </ng-template>
    }

    <ng-template [appEditTab]="Tabs.CoverImage">
      <app-cover-image-chooser [config]="chooserConfig()" (coverChanged)="handleCoverChanged($event)" (resetClicked)="handleReset()" />
    </ng-template>

    @if (tag().source !== ScrobbleProvider.Kavita) {
      <ng-template [appEditTab]="Tabs.Info">
        <div class="row g-0 mb-2">
          <div class="col-md-6">
            <div>{{t('last-sync-title')}}</div>
            <div>{{tag().lastSyncUtc | utcToLocalTime:'shortDate' | defaultDate}}</div>
          </div>
          <div class="col-md-6">
            <div>{{t('source-url-title')}}</div>
            <a [href]="tag().sourceUrl | safeUrl" rel="noopener noreferrer" target="_blank">{{tag().sourceUrl}}</a>
          </div>
        </div>
        <div class="row g-0 mb-2">
          <div class="col-md-6">
            <div>{{t('total-series-title')}}</div>
            <div>{{tag().totalSourceCount | number}}</div>
          </div>
          <div class="col-md-6">
            <div>{{t('missing-series-title')}}</div>
            <div>{{tag().totalSourceCount - series().length}}</div>
          </div>
        </div>

        @let missingSeriesFromSource = tag().missingSeriesFromSource;
        @if (missingSeriesFromSource !== null && (tag().totalSourceCount - series().length) > 0) {
          <h6>{{t('missing-series-title')}}</h6>
          <div class="row g-0">
            <p [innerHTML]="missingSeriesFromSource | safeHtml"></p>
          </div>
        }
      </ng-template>
    }

  </app-edit-modal-shell>

</ng-container>
